// Descrição do produto: recolhe textos longos e só mostra o botão quando o
// texto realmente passa do limite de linhas.

{
  class MaAuto extends HTMLElement {
    connectedCallback() {
      this.texto = this.querySelector('[data-texto]');
      this.botao = this.querySelector('[data-alternar]');
      this.rotulo = this.querySelector('[data-rotulo]');
      if (!this.texto || !this.botao) return;

      this.linhas = parseInt(this.dataset.linhas, 10) || 4;
      this.style.setProperty('--ma-auto-linhas', this.linhas);
      this.textoMais = this.rotulo ? this.rotulo.textContent.trim() : 'Ler mais';
      this.textoMenos = this.dataset.menos || 'Ler menos';

      this.dataset.recolhido = 'true';
      this.avaliar();

      this.botao.addEventListener('click', () => this.alternar());
      // A fonte carrega depois e muda a altura do texto
      if (document.fonts) document.fonts.ready.then(() => this.avaliar());
      window.addEventListener('resize', () => this.avaliar());
    }

    // Sem transbordo, o botão não tem função e não aparece
    avaliar() {
      if (this.dataset.recolhido !== 'true') return;
      const transborda = this.texto.scrollHeight > this.texto.clientHeight + 2;
      this.botao.hidden = !transborda;
    }

    alternar() {
      const recolhido = this.dataset.recolhido === 'true';
      this.dataset.recolhido = recolhido ? 'false' : 'true';
      if (this.rotulo) this.rotulo.textContent = recolhido ? this.textoMenos : this.textoMais;
      if (!recolhido) this.avaliar();
    }
  }

  if (!customElements.get('ma-auto')) customElements.define('ma-auto', MaAuto);
}
